import React, { createContext, useState, ReactNode, useEffect, useContext } from 'react';
import { RouteComponentProps } from '@reach/router';
import { CrossButton } from '../Button';
import { StyledFullScreenWrapper } from '../Styled';
import { EditToolContext } from '../../contexts/editToolContext';

interface IFullScreen extends RouteComponentProps {
  children: ReactNode;
  screenToDisplay?: string;
  page?: string;
}

type Dispatch = (value: boolean) => void;

export const ScreenContext = createContext<{
  fullScreen: Array<boolean | Dispatch>;
}>({
  fullScreen: [],
});

export const FullScreen: React.FC<IFullScreen> = (props): JSX.Element => {
  const { children, screenToDisplay, navigate } = props;
  const [isFullScreen, setFullScreen] = useState(screenToDisplay === 'full-screen');
  const { handleLeavePage } = useContext(EditToolContext);

  const handleNavigate = (url: string) => {
    navigate && navigate(url);
  };

  const handleCrossClick = () => {
    const toUrl = location.pathname.replace('/full-screen/', '/default/') + location.search;

    if (handleLeavePage(() => handleNavigate(toUrl), true)) {
      return;
    }

    handleNavigate(toUrl);
  };

  useEffect(() => {
    screenToDisplay === 'full-screen' ? setFullScreen(true) : setFullScreen(false);
  }, [screenToDisplay]);

  const renderFullScreen = () => {
    return (
      <StyledFullScreenWrapper data-testid={isFullScreen ? 'full-screen' : 'default'} isFullScreen={isFullScreen}>
        <CrossButton
          ariaLabel="exit full screen"
          testId="cross-button"
          onClick={handleCrossClick}
          visible={screenToDisplay === 'full-screen'}
        />
        {children}
      </StyledFullScreenWrapper>
    );
  };

  return (
    <ScreenContext.Provider value={{ fullScreen: [isFullScreen, setFullScreen] }}>
      {renderFullScreen()}
    </ScreenContext.Provider>
  );
};
